import React from 'react';

import BusinessNameStep from './BusinessNameStep';
import BusinessNumberStep from './BusinessNumberStep';
import Preference1Step from './Preference1Step';
import Preference2Step from './Preference2Step';
import TeamSizeStep from './TeamSizeStep';

export interface StepProps {
  onNext: () => void;
}

export const steps: { name: string; component: React.ComponentType<StepProps> }[] = [
  {
    name: 'Your clinic name',
    component: BusinessNameStep,
  },
  {
    name: 'Your clinic number',
    component: BusinessNumberStep,
  },
  {
    name: 'Your Priority',
    component: Preference1Step,
  },
  {
    name: "What's missing",
    component: Preference2Step,
  },
  {
    name: 'Team size',
    component: TeamSizeStep,
  },
];
